<!-- Error page-->
<div class="misc-wrapper mt-lg-n3">
    <div class="misc-inner" [ngClass]="{'is-p-5':isPageView}">

<ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="onTabChange()" [(activeId)]="active">
    <li ngbNavItem [ngbNavItem]="1" [disabled]="processState !== paymentStage.PROVIDE_PAYMENT_PLAN">
      <a ngbNavLink>Zeraki Learning</a>
      <ng-template ngbNavContent>
       <!-- pay-padding -->
       <div class="d-lg-flex">
        <div class="w-100">

              <!-- stepper -->
          <div class="progress-container mb-md-3">
            <div class="progress" [style.width.%]="progress"></div>
            <div class="circle" [class.active]="step >= 1">1</div>
            <div class="circle" [class.active]="step >= 2">2</div>
            <!-- <p>Confirm</p> -->
            <!-- <div class="circle" [class.active]="step >= 3">3</div>
            <div class="circle" [class.active]="step >= 4">4</div>
            <div class="circle" [class.active]="step >= 5">5</div> -->
          </div>
            <h4 class="text-center text-black font-medium-5">{{ processState < 2 ? "Select Plan" : "Make Payment for Zeraki Learning" }}</h4>
            <hr class="mb-md-0" >

            <div style="display: flex; flex-direction: column; justify-content: center; min-height: 28rem">

                <!-- First view. == Collect payment plan -->
                <app-provide-subscription-plan
                        *ngIf="processState == paymentStage.PROVIDE_PAYMENT_PLAN"
                        (loadHomepageEvt)="loadHomepage()"
                        (planEvt)="getPaymentPlan($event)"
                        (phoneNumberEvt)="getPaymentPlan($event)"
                        (discountAppliedEvt)="getDiscountCode($event)"
                        [plans]="plans"
                        [careersPlans]="careersPlan"
                        [isLoading]="isLoadingPlans">
                </app-provide-subscription-plan>

                <!-- Second view. == Display confirmation amount details -->
                <div *ngIf="processState == paymentStage.CONRIFM_PAYMENT">
                    <div class="payment-confirmation">
                        <div class="card-body d-flex flex-column align-items-center">
                            <img src="../../../../assets/img/Group 5511.png" class="mb-2 mb-md-3" alt="">
                            <div class="price-details">
                                <ng-container *ngIf="planName === 'careers';else normalPlans">
                                    <p class="mb-0 text-center font-medium-1 font-weight-bolder text-black">You are about to pay <strong style="color: rgba(1, 120, 121, 1);">{{careersPlan?.amount | currency:'KES'}}</strong>
                                        for the <strong style="color: rgba(1, 120, 121, 1);">{{paymentInfo?.careerTopic?.title}} career videos </strong>valid for 1 year</p>
                                </ng-container>
                                <ng-template #normalPlans>
                                    <p class="mb-0 text-center font-medium-1 font-weight-bolder text-black">You are about to pay <strong style="color: rgba(1, 120, 121, 1);">{{(paymentInfo?.plan?.hasDiscount ? paymentInfo?.plan?.discountedAmount : paymentInfo?.plan?.amount) | currency:'KES'}}</strong>
                                        for your <strong style="color: rgba(1, 120, 121, 1);">{{paymentInfo?.plan?.planName}}</strong></p>
                                </ng-template>
                                <p class="text-center text-black font-medium-1 mb-0 mt-1">Click "Make Payment" to continue</p>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                    <div class="mb-0 mt-md-2" [ngClass]="{'w-75':processState == paymentStage.CONRIFM_PAYMENT }">
                        <button (click)="approvePaymentInfo()" class="btn btn-primary btn-md btn-block font-weight-bolder waves-effect waves-light mb-1">Make payment</button>
                  <button (click)="cancelPaymentInfo()" class="btn btn-outline-danger btn-md btn-block font-weight-bolder">Cancel</button>
                      </div>
                    </div>
                </div>

                <!--Third view. == Display Instruction View -->
                <app-payment-instruction
                        [coreConfig]="coreConfig"
                        [paymentInfo]="paymentInfo"
                        [careersPlan]="careersPlan"
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_INSTRUCTIONS"
                        (loadHomepageEvt)="loadHomepage()"
                        (addSubscriptionEvt)="addSubscription()"></app-payment-instruction>

                <!-- Fourth. Display verify Payment view-->
                <app-payment-verify
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_VERIFY"
                        (loadHomepageEvt)="loadHomepage()"
                        [coreConfig]="coreConfig"></app-payment-verify>

                <app-payment-success
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_SUCCESS"
                        [coreConfig]="coreConfig"
                        [planName]="getPlanName()"
                        [expiryDate]="getExpiryDate()"
                ></app-payment-success>

                <app-payment-success-mobile
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_SUCCESS_FOR_MOBILE"
                        [coreConfig]="coreConfig"
                        [planName]="getPlanName()"
                        [expiryDate]="getExpiryDate()"
                ></app-payment-success-mobile>

                <app-payment-error
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_FAILED"
                        (loadHomepageEvt)="loadHomepage()"
                        [coreConfig]="coreConfig"
                        (addSubscriptionEvt)="retryAfterFailure()"
                ></app-payment-error>

            </div>
        </div>
    </div>
      </ng-template>
    </li>
    <li ngbNavItem [ngbNavItem]="2" [disabled]="processState !== paymentStage.PROVIDE_PAYMENT_PLAN">
      <a ngbNavLink>Beewiz</a>
      <ng-template ngbNavContent>
            <!-- pay-padding -->
       <div class="d-lg-flex">
        <div class="w-100">

              <!-- stepper -->
          <div class="progress-container mb-md-3">
            <div class="progress" [style.width.%]="progress"></div>
            <div class="circle" [class.active]="step >= 1">1</div>
            <div class="circle" [class.active]="step >= 2">2</div>
            <!-- <p>Confirm</p> -->
            <!-- <div class="circle" [class.active]="step >= 3">3</div>
            <div class="circle" [class.active]="step >= 4">4</div>
            <div class="circle" [class.active]="step >= 5">5</div> -->
          </div>
          <h4 class="text-center text-black font-medium-5">{{ processState < 2 ? "Make Payment for Beewiz Contests" : "Make Payment for Zeraki Learning" }}</h4>
          <hr class="mb-md-0" >

            <div style="display: flex; flex-direction: column; justify-content: center; min-height: 28rem">

                <!-- First view. == Collect payment plan -->
                <app-provide-subscription-plan
                        *ngIf="processState == paymentStage.PROVIDE_PAYMENT_PLAN"
                        (loadHomepageEvt)="loadHomepage()"
                        (planEvt)="getPaymentPlan($event)"
                        (phoneNumberEvt)="getPaymentPlan($event)"
                        (discountAppliedEvt)="getDiscountCode($event)"
                        [plans]="plans"
                        [careersPlans]="careersPlan"
                        [isLoading]="isLoadingPlans">
                </app-provide-subscription-plan>

                <!-- Second view. == Display confirmation amount details -->
                <div *ngIf="processState == paymentStage.CONRIFM_PAYMENT">
                    <div class="payment-confirmation">
                        <div class="card-body d-flex flex-column align-items-center">
                            <img src="../../../../assets/img/Group 5511.png" class="mb-2 mb-md-3" alt="">
                            <div class="price-details">
                                <ng-container *ngIf="planName === 'careers';else normalPlans">
                                    <p class="mb-0 text-center font-medium-1 font-weight-bolder text-black">You are about to pay <strong style="color: rgba(1, 120, 121, 1);">{{careersPlan?.amount | currency:'KES'}}</strong>
                                        for the <strong style="color: rgba(1, 120, 121, 1);">{{paymentInfo?.careerTopic?.title}} career videos </strong>valid for 1 year</p>
                                </ng-container>
                                <ng-template #normalPlans>
                                    <p class="mb-0 text-center font-medium-1 font-weight-bolder text-black">You are about to pay <strong style="color: rgba(1, 120, 121, 1);">{{(paymentInfo?.plan?.hasDiscount ? paymentInfo?.plan?.discountedAmount : paymentInfo?.plan?.amount) | currency:'KES'}}</strong>
                                        for your <strong style="color: rgba(1, 120, 121, 1);">{{paymentInfo?.plan?.planName}}</strong></p>
                                </ng-template>
                                <p class="text-center text-black font-medium-1 mb-0 mt-1">Click "Make Payment" to continue</p>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                    <div class="mb-0 mt-md-2" [ngClass]="{'w-75':processState == paymentStage.CONRIFM_PAYMENT }">
                        <button (click)="approvePaymentInfo()" class="btn btn-primary btn-md btn-block font-weight-bolder waves-effect waves-light mb-1">Make payment</button>
                  <button (click)="cancelPaymentInfo()" class="btn btn-outline-danger btn-md btn-block font-weight-bolder">Cancel</button>
                      </div>
                    </div>
                </div>

                <!--Third view. == Display Instruction View -->
                <app-payment-instruction
                        [coreConfig]="coreConfig"
                        [paymentInfo]="paymentInfo"
                        [careersPlan]="careersPlan"
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_INSTRUCTIONS"
                        (loadHomepageEvt)="loadHomepage()"
                        (addSubscriptionEvt)="addSubscription()"></app-payment-instruction>

                <!-- Fourth. Display verify Payment view-->
                <app-payment-verify
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_VERIFY"
                        (loadHomepageEvt)="loadHomepage()"
                        [coreConfig]="coreConfig"></app-payment-verify>

                <app-payment-success
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_SUCCESS"
                        [coreConfig]="coreConfig"
                        [planName]="getPlanName()"
                        [expiryDate]="getExpiryDate()"
                ></app-payment-success>

                <app-payment-success-mobile
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_SUCCESS_FOR_MOBILE"
                        [coreConfig]="coreConfig"
                        [planName]="getPlanName()"
                        [expiryDate]="getExpiryDate()"
                ></app-payment-success-mobile>

                <app-payment-error
                        *ngIf="processState == paymentStage.DISPLAY_PAYMENT_FAILED"
                        (loadHomepageEvt)="loadHomepage()"
                        [coreConfig]="coreConfig"
                        (addSubscriptionEvt)="retryAfterFailure()"
                ></app-payment-error>

            </div>
        </div>
    </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>

 <!-- end -->

    </div>
</div>
<!-- / Error page-->